/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {
  Dialog,
} from '@material-ui/core';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import InnerImageZoom from 'react-inner-image-zoom';

const useStyles = makeStyles(() => createStyles(
  {
    dialogPaper: {
      overflow: 'hidden',
      maxHeight: '95vh',
      boxShadow: 'none',
    },
  },
));

const ImageModal: React.FC<{
  open:boolean,
  onCloseFunction: () => void,
  imageUrls: string[]
}> = ({ open, onCloseFunction, imageUrls }) => {
  const classes = useStyles();

  return (
    <Dialog
      maxWidth="lg"
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={onCloseFunction}
      closeAfterTransition
      classes={{ paper: classes.dialogPaper }}
    >
      <IconButton
        onClick={onCloseFunction}
        style={{
          position: 'absolute', top: '24px', right: '24px', zIndex: 100000000,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Carousel
        width="auto"
        useKeyboardArrows
        showArrows={imageUrls.length > 1}
        showIndicators={imageUrls.length > 1}
        showThumbs={imageUrls.length > 1}
        showStatus={false}
        autoFocus
      >
        {
                imageUrls.map((item) => (
                  <InnerImageZoom
                    src={item}
                    zoomType="click"
                    zoomScale={1.5}
                  />
                ))
            }
      </Carousel>
    </Dialog>
  );
};

export default ImageModal;
